module.exports = __webpack_public_path__ + "img/iceskating003.52619cba.jpg";